import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitRoutingModule } from './split-routing.module';
import { SplitButtonComponent } from './splitButton.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {SplitButtonModule} from "../../component/ing/splitbutton/splitbutton";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    SplitRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    SplitButtonModule,
    TableModule
  ],
  declarations: [
  	SplitButtonComponent
  ]
})
export class SplitButtonDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/splitButton/splitButtonDemo.module.ts